import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Typography, Card, Flex, Tag, Empty, Spin, theme } from "antd";
import { RocketOutlined } from "@ant-design/icons";
import { useQ_PageFlowSelector_Flows } from "@/hooks/FlowSelector/useQ_PageFlowSelector_Flows";
import type { Supabase_Enums } from "@gotoIHUB/db-types";

export const Route = createFileRoute("/_protected/$organizationId/")({
  component: Page_FlowSelector,
});

const STATUS_COLORS: Record<string, string> = {
  active: "success",
  disabled: "error",
};

function Page_FlowSelector() {
  const { token } = theme.useToken();
  const { organizationId } = Route.useParams();
  const navigate = useNavigate();
  const qFlows = useQ_PageFlowSelector_Flows({ organizationId });

  if (qFlows.query.isLoading) {
    return (
      <Flex justify="center" align="center" style={{ minHeight: 300 }}>
        <Spin size="large" />
      </Flex>
    );
  }

  if (qFlows.orgFlows.length === 0) {
    return (
      <Flex justify="center" align="center" style={{ minHeight: 300 }}>
        <Empty description="No flows available for this organization. Contact your administrator to request access." />
      </Flex>
    );
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: token.paddingLG }}>
      <Typography.Title level={2} style={{ marginBottom: token.marginLG }}>
        Select a Flow
      </Typography.Title>
      <Flex gap={token.marginMD} wrap="wrap">
        {qFlows.orgFlows.map((of) => {
          const flow = of.flows as { id: string; slug: string; name: string; carrier: string; status: Supabase_Enums<"flow_status_enum"> } | null;
          if (!flow) return null;
          return (
            <Card
              key={flow.id}
              hoverable
              style={{ width: 280, cursor: "pointer" }}
              onClick={() => navigate({ to: "/$organizationId/$flowId/sessions", params: { organizationId, flowId: flow.slug } })}
            >
              <Flex align="center" gap={token.marginSM} style={{ marginBottom: token.marginSM }}>
                <RocketOutlined style={{ fontSize: token.fontSizeXL, color: token.colorPrimary }} />
                <Typography.Title level={4} style={{ margin: 0 }}>{flow.name}</Typography.Title>
              </Flex>
              <Flex justify="space-between" align="center">
                <Typography.Text type="secondary">{flow.carrier}</Typography.Text>
                <Tag color={STATUS_COLORS[flow.status] ?? "default"}>{flow.status}</Tag>
              </Flex>
            </Card>
          );
        })}
      </Flex>
    </div>
  );
}
